import Portal from "@Portals/components/Portal";
import BestPriceOnDateRouteList from "@Pages/stationToStation/components/BestPriceOnDateRouteList";
import BestPriceRouteType from "@Pages/stationToStation/types/BestPriceRoute.type";
import React, {useEffect} from "react";
import PortalMap from "@Portals/components/PortalMap";
import DepartureStationPopover
    from "@Pages/stationToStation/features/departureStationPopover/components/DepartureStationPopover";
import StsBusChangeContainer from "@Pages/stationToStation/components/StsBusChangeContainer";
import MTicketPopover from "@Pages/stationToStation/features/mTicketPopover/components/MTicketPopover";
import PricePopover from "@Pages/stationToStation/features/pricePopover/components/PricePopover";
import StationToStationDatePicker from "@Pages/stationToStation/components/StationToStationDatePicker";
import useFerrySupportedLocale from "@GetByFerry/hooks/useFerrySupportedLocale";
import GenericPopover from "@Popover/components/GenericPopover";
import {useTranslation} from "@Translation/hooks/useTranslation";
import {StsCompanyRating} from "@Pages/stationToStation/components/StsCompanyRating";
import {BestPriceTabs} from "@Pages/stationToStation/features/bestPriceTabs/components/BestPriceTabs";
import {TravelBestPricePortal} from "@Pages/stationToStation/components/TravelBestPricePortal";
import IconInfo from "@Icons/IconInfo";
import {Colors} from "@Styles/Colors.style";

interface BestPriceOnDatePortalProps {
    stationToStationHasResults: boolean,
    portToPortHasResults: boolean,
    travelPageHasResults: boolean,
    isTravelPage: boolean,
}

function BestPriceOnDatePortal({stationToStationHasResults, portToPortHasResults, travelPageHasResults, isTravelPage}: BestPriceOnDatePortalProps) {
    const {
        locale,
        transportType,
    } = useFerrySupportedLocale();

    const trigger = () => {
        return (
            <IconInfo fill={Colors.neutralBlackColor}/>
        )
    }

    const overlayContent :string = useTranslation("sts_page.info_button_content");

    // Probably the wrong way to do this,
    // but keeping the logic the same as the original code for the mobile display of the datepicker
    useEffect(() => {
        const panels = document.querySelectorAll('.panel');
        panels.forEach((panel) => {
            const handleClick = () => {
                const button = panel.querySelector('.btn.btn--blue.sts-date-picker-text');
                if (button) {
                    button.click();
                }
            };
            panel.addEventListener('click', handleClick);

            // Cleanup event listener on component unmount
            return () => {
                panel.removeEventListener('click', handleClick);
            };
        });
    }, []);

    if (travelPageHasResults) {
        return (
            <>
                <Portal
                    id="travelRoutes"
                    type="div"
                >
                    <TravelBestPricePortal bestPriceOnDateRoutes={window?.bestPriceOnDateDataTravel}/>
                </Portal>
                <Portal id="review-info">
                    <GenericPopover
                        trigger={trigger()}
                        overlay={overlayContent}
                        id="review-info"
                    />
                </Portal>
            </>
        )
    }

    if (stationToStationHasResults) {
        return (
            <>
                <Portal
                    id="popularBusRoutes"
                    type="div"
                >
                    <BestPriceOnDateRouteList
                        bestPriceOnDateData={(window.bestPriceOnDateData as Record<number, BestPriceRouteType[]>)[1]}
                    />
                </Portal>
                <Portal
                    id="popularTrainRoutes"
                    type="div"
                >
                    <BestPriceOnDateRouteList
                        bestPriceOnDateData={(window.bestPriceOnDateData as Record<number, BestPriceRouteType[]>)[3]}
                    />
                </Portal>
                {window.bestPriceOnDateDataOverNightTrips && (
                    <Portal
                        id="overnightPopularBusRoutes"
                        type="div"
                    >
                        <BestPriceOnDateRouteList
                            bestPriceOnDateData={(window.bestPriceOnDateDataOverNightTrips as Record<number, BestPriceRouteType[]>)[1]}
                        />
                    </Portal>
                )}
                <Portal id="review-info">
                    <GenericPopover
                        trigger={trigger()}
                        overlay={overlayContent}
                        id="review-info"
                    />
                </Portal>
            </>
        )
    }

    if (portToPortHasResults) {
        return (
            <>
                <Portal
                    id="gb--best-price-on-date-ferry"
                    type="div"
                >
                    <BestPriceOnDateRouteList
                        bestPriceOnDateData={window.bestPriceOnDateData as BestPriceRouteType[]}
                    />
                </Portal>
                <Portal id="review-info">
                    <GenericPopover
                        trigger={trigger()}
                        overlay={overlayContent}
                        id="review-info"
                    />
                </Portal>
            </>
        )
    }

    return (
        <>
            <PortalMap className="result-tabs">
                <BestPriceTabs/>
            </PortalMap>
            <PortalMap className="gb--departure gb--truncate">
                <DepartureStationPopover/>
            </PortalMap>

            <PortalMap className="gb--bus-change">
                <StsBusChangeContainer/>
            </PortalMap>

            <PortalMap className="gb--route-ticket_type">
                <MTicketPopover/>
            </PortalMap>

            <PortalMap className="gb--route-price">
                <PricePopover/>
            </PortalMap>

            <PortalMap className="company-rating__score">
                <StsCompanyRating/>
            </PortalMap>

            <PortalMap className="gb--route-datepicker">
                <StationToStationDatePicker
                    locale={locale}
                    transportType={transportType}
                />
            </PortalMap>
            <Portal id="review-info">
                <GenericPopover
                    trigger={trigger()}
                    overlay={overlayContent}
                    id="review-info"
                />
            </Portal>
        </>
    )
}

export default BestPriceOnDatePortal